import { useEffect, useState } from 'react';

import { useAmplitude } from './AmplitudeProvider';

export function useFeatureFlag(
    flagName: string,
    defaultValue = false,
    variantName = 'on'
) {
    const { experiment } = useAmplitude();

    const [isEnabled, setIsEnabled] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (experiment) {
            const flag = experiment.variant(flagName);

            setIsLoading(false);

            if (flag?.value === variantName) {
                setIsEnabled(true);
            } else {
                setIsEnabled(false);
            }
        }
    }, [defaultValue, experiment, flagName, variantName]);

    return { isEnabled, isLoading };
}
